<template>
    <div class="col-12 col-md-5">
        <div class="d-flex flex-column flex-xl-row align-items-md-start align-items-lg-center justify-content-around gap- gap-lg-3">
            <h5 class="d-inline-block d-sm-block mb-2 mb-lg-0">Check earliest fitting dates</h5>
            <VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit">
                <form class="postcode-form d-flex" @submit="handleSubmit($event, onPostcodeSubmit)" method="post" :action="this.baseUrl + '/update-tyres'">
                    <Popper :content="errors.checkPostcode" arrow placement="top" class="d-inline-block m-0 border-0" :show="errors.checkPostcode ? true : false">
                        <Field id="checkPostcode" name="checkPostcode" type="text" class="form-control postcode uppercase" :value="postcode" placeholder="Enter postcode"/>
                    </Popper>
                    <button type="submit" class="btn btn-sm btn-primary d-inline-block py-1 ms-2">
                        Go
                    </button>
                </form>
            </VeeForm>
        </div>
    </div>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';

    export default {
        props: ['postcode'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const postcodeValidationSchema = yup.object({
                'checkPostcode': yup.string().required('postcode is a required field').nullable()
            });

            return {
                postcodeValidationSchema
            }
        },
        methods: {
            onPostcodeSubmit(values) {
                this.emitter.emit('isLoading', true);
                
                let vm = this;
                var postcode = values.checkPostcode;
                var formData = new FormData();
                formData.append('postcode', postcode);

                //TO DO - check postcode is valid

                axios.post('/ajax/earliest_fitting_postcode', formData)
                .then(response => {
                    if(response.data.postcode_updated == true)
                    {
                        vm.$parent.selectFilter(vm.$parent.homeDelivery);
                        //Update parents postcode with updated postcode
                        vm.$emit('updatedPostcode', postcode);
                    }
                    else {
                        console.log('Postcode not updated');
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>
    h5 {
        font-size: 17px;
        margin: 0;
    }
    .postcode {
        width: 200px;
    }
</style>